module.exports = __webpack_public_path__ + "img/twitter-icon.4d19fcb8.svg";